export function record_browser_timings() {
  if (window.performance && window.performance.timing) {
    // This is deliberately *after* the ready event, so we can get the full
    // timing information
    $(window).on('load', function () {
      const data = _.extend(
        {
          url: '' + window.location,
        },
        window.performance.timing.toJSON(),
      );
      new Aedu.Server.Notification('dev_timings').notify(data);
    });
  }
}

export default record_browser_timings;
